
export const gradients = [
  'linear-gradient(135deg, #74ABE2, #4A90E2)', // A (blue)
  'linear-gradient(135deg, #E25C5C, #C0392B)', // B (red)
  'linear-gradient(135deg, #A8E063, #7CB342)', // C (green)
  'linear-gradient(135deg, #FFD54F, #FFA000)', // D (orange)
  'linear-gradient(135deg, #43CEA2, #2AB598)', // E (teal)
  'linear-gradient(135deg, #F48FB1, #EC407A)', // F (pink)
  'linear-gradient(135deg, #64B5F6, #1976D2)', // G (blue)
  'linear-gradient(135deg, #FF8A65, #F4511E)', // H (coral)
  'linear-gradient(135deg, #4FC3F7, #0288D1)', // I (sky blue)
  'linear-gradient(135deg, #BA68C8, #8E24AA)', // J (purple)
  'linear-gradient(135deg, #81C784, #43A047)', // K (green)
  'linear-gradient(135deg, #9575CD, #673AB7)', // L (purple)
  'linear-gradient(135deg, #FFD54F, #FFA000)', // M (orange)
  'linear-gradient(135deg, #4DB6AC, #00897B)', // N (teal)
  'linear-gradient(135deg, #F48FB1, #EC407A)', // O (pink)
  'linear-gradient(135deg, #7986CB, #3F51B5)', // P (blue)
  'linear-gradient(135deg, #DCE775, #C0CA33)', // Q (lime)
  'linear-gradient(135deg, #9575CD, #673AB7)', // R (purple)
  'linear-gradient(135deg, #4DB6AC, #00897B)', // S (teal)
  'linear-gradient(135deg, #F48FB1, #EC407A)', // T (pink)
  'linear-gradient(135deg, #4FC3F7, #0288D1)', // U (sky blue)
  'linear-gradient(135deg, #81C784, #43A047)', // V (green)
  'linear-gradient(135deg, #64B5F6, #1976D2)', // W (blue)
  'linear-gradient(135deg, #7986CB, #3F51B5)', // X (blue)
  'linear-gradient(135deg, #BA68C8, #8E24AA)', // Y (purple)
  'linear-gradient(135deg, #4DB6AC, #00897B)', // Z (teal)
];

export function ABG(name) {
  const firstChar = name?.charAt(0)?.toUpperCase() || 'A';
  const charCode = firstChar.charCodeAt(0);
  const index = (charCode - 65) % gradients.length;
  return {
    background: gradients[index],
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    fontWeight: 600,
    fontSize: '35px',
    color: '#fff',
    textTransform: 'uppercase',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
  };
}
